export class UserCompanyModel {
  userId: string;
  companyId: string;
  companyName: string;
  isActive: boolean;
  userCompanyId: string;
  accessToAllJobs: boolean;
  displayText: string;
}
